import { render, staticRenderFns } from "./CompManage.vue?vue&type=template&id=98b0cfc2&scoped=true&"
import script from "./CompManage.vue?vue&type=script&lang=js&"
export * from "./CompManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b0cfc2",
  null
  
)

export default component.exports